import * as z from 'zod';

/**
 * Canonical rich-note body: Tiptap/ProseMirror JSON (format tiptap_json_v1).
 * This is the structural shape only; the domain additionally validates the
 * document against the editor schema before saving it.
 */
export type EditorMark = { type: string; attrs?: Record<string, unknown> };
export type EditorNode = {
  type: string;
  attrs?: Record<string, unknown>;
  content?: EditorNode[];
  marks?: EditorMark[];
  text?: string;
};
export type EditorDocument = { type: 'doc'; content?: EditorNode[] };

const EditorMarkSchema = z.object({
  type: z.string().min(1).max(64),
  attrs: z.record(z.string(), z.unknown()).optional(),
});

export const EditorNodeSchema: z.ZodType<EditorNode> = z.lazy(() =>
  z.object({
    type: z.string().min(1).max(64),
    attrs: z.record(z.string(), z.unknown()).optional(),
    content: z.array(EditorNodeSchema).optional(),
    marks: z.array(EditorMarkSchema).optional(),
    text: z.string().optional(),
  }),
);

export const EditorDocumentSchema = z.object({
  type: z.literal('doc'),
  content: z.array(EditorNodeSchema).optional(),
});

export const NOTE_FORMAT = 'tiptap_json_v1' as const;
/** Upper bound for one saved note body (serialized JSON), keeping saves and reads bounded. */
export const MAX_NOTE_JSON_BYTES = 2_000_000;
